// extracted by mini-css-extract-plugin
export default {"autoSaveInputWrap":"withAutoSave_autoSaveInputWrap__Vh5KE","autoSaveInputProgress":"withAutoSave_autoSaveInputProgress__DllpQ"};